"use strict";

/**
 * Cart page.
 *
 * The line items are the drawer's own c-cart-item component, which posts
 * quantity and removal changes to /cart/update.js and then publishes
 * "cart:update". This element listens for that and re-renders itself from
 * its own section HTML, so the totals and the discount ladder stay in step
 * with the items. Same strategy as the drawer, including its fallback
 * ladder for stores where "/?section_id=" returns a 500.
 */
(function () {
  class SCartPage extends HTMLElement {
    constructor() {
      super();
      this.sectionId = null;
      this.headerItemCount = null;
      this.update = this.update.bind(this);
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.headerItemCount = document.querySelector(".cart-link__bubble-num");

      if (window.PubSub && window.PubSub.subscribe) {
        window.PubSub.subscribe("cart:update", this.update);
      }
    }

    async fetchSectionHTML() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const handle = encodeURIComponent(this.sectionId);

      const candidates = [
        `${root}cart?section_id=${handle}`,
        `${root}?section_id=${handle}`
      ];

      for (const url of candidates) {
        try {
          const response = await fetch(url, { credentials: "same-origin", cache: "no-store" });
          if (!response.ok) continue;

          const html = await response.text();
          if (html && html.includes("s-cart-page")) return html;
        } catch (error) {
          console.warn("[s-cart-page] section fetch failed:", url, error);
        }
      }

      try {
        const response = await fetch(`${root}?sections=${handle}`, {
          credentials: "same-origin",
          cache: "no-store"
        });

        if (response.ok) {
          const data = await response.json();
          const html = data && data[this.sectionId];
          if (html && html.includes("s-cart-page")) return html;
        }
      } catch (error) {
        console.warn("[s-cart-page] JSON section fetch failed:", error);
      }

      return null;
    }

    async update() {
      this.classList.add("is-loading");

      try {
        const html = await this.fetchSectionHTML();
        if (!html) {
          console.error("[s-cart-page] Could not fetch section HTML.");
          return;
        }

        const temp = document.createElement("div");
        temp.innerHTML = html;

        const fresh = temp.querySelector("s-cart-page");
        if (!fresh) {
          console.error("[s-cart-page] Section HTML did not include s-cart-page.");
          return;
        }

        this.innerHTML = fresh.innerHTML;

        const countEl = this.querySelector(".js-cart-page__count");
        if (countEl && this.headerItemCount) {
          this.headerItemCount.innerHTML = countEl.dataset.cartCount || "";
        }
      } catch (error) {
        console.error("[s-cart-page] update failed:", error);
      } finally {
        this.classList.remove("is-loading");
      }
    }
  }

  if (!customElements.get("s-cart-page")) {
    customElements.define("s-cart-page", SCartPage);
  }
})();
